function initScrollbarFix() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  document.documentElement.classList.add('prevent-scroll-jump');
}

initScrollbarFix();

window.addEventListener('resize', initScrollbarFix);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMenu);
} else {
  initMenu();
}

function initMenu() {
  if (document.querySelectorAll('.bwc-main-menu').length) {
    import('./_main-menu-bwc.js').then((module) => {
      module.Init();
    }).catch(error => {
      console.error('Error importing module:', error);
    });
  }
}

export default class MainMenuBwc {
  constructor() {
    this.openMenuButton = document.querySelector('.navigation-bar-bars');
    this.closeMenuButton = document.querySelector('.main-menu-close');
    this.mainMenuCanvas = document.querySelector('.main-menu-canvas');
    this.mainMenuOverlay = document.querySelector('.main-menu-overlay');
    this.body = document.body;

    if (this.mainMenuCanvas) {
      this.mainMenuCanvas.inert = true;
      if (this.mainMenuCanvas.hasAttribute('aria-hidden')) {
        this.mainMenuCanvas.removeAttribute('aria-hidden');
      }
    }

    this.init();
  }

  init() {
    if (this.openMenuButton) {
      this.openMenuButton.addEventListener('click', () => this.openMenu());
    }
    if (this.closeMenuButton) {
      this.closeMenuButton.addEventListener('click', () => this.closeMenu());
    }
    if (this.mainMenuOverlay) {
      this.mainMenuOverlay.addEventListener('click', () => this.closeMenu());
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.body.classList.contains('main-menu-is-open')) {
        this.closeMenu();
      }
    });
  }

  openMenu() {
    if (this.mainMenuCanvas && this.mainMenuOverlay && this.body) {
      this.body.classList.add('main-menu-is-open');
      this.mainMenuCanvas.inert = false;
      this.mainMenuOverlay.setAttribute('aria-hidden', 'false');

      if (this.closeMenuButton) {
        this.closeMenuButton.classList.add('animate-on-open');
      }
    }
  }

  closeMenu() {
    if (this.mainMenuCanvas && this.mainMenuOverlay && this.body) {
      this.body.classList.remove('main-menu-is-open');
      this.mainMenuCanvas.inert = true;
      this.mainMenuOverlay.setAttribute('aria-hidden', 'true');

      if (this.closeMenuButton) {
        setTimeout(() => {
            this.closeMenuButton.classList.remove('animate-on-open');
        }, 500);
      }
    }
  }
}

if (document.querySelector('.bwc-main-menu')) {
  new MainMenuBwc();
}
